import apiInstance from "./apiInstance";

const getSiteSettings = () => {
  return apiInstance.get("site-settings");
};

const getSiteSettingByType = (type) => {
  return apiInstance.get(`site-settings/sha1/${type}`);
};

const updateSiteSettings = (settings) => {
  return apiInstance.post("site-settings", settings);
};

const getExtraSetting = (key) => {
  return apiInstance.get(`site-settings/extra-settings/${key}`);
};

const getSuperAdmins = () => {
  return apiInstance.get("/operationsmsverification/superadmin/list");
};

const addSuperAdmin = (data) => {
  return apiInstance.post(`/operationsmsverification/superadmin?userId=${data.userId}`);
};

const deleteSuperAdmin = (id) => {
  return apiInstance.delete(`/operationsmsverification/superadmin?userId=${id}`);
};

export {
  getSiteSettings,
  getSiteSettingByType,
  updateSiteSettings,
  getExtraSetting,
  getSuperAdmins,
  addSuperAdmin,
  deleteSuperAdmin
};
